import React, { useMemo } from 'react';
import { GetF29Comments, CreateF29Comment } from 'src/graphql/f29';
import RepositoryCommentsTab from 'src/components/repositorio/RepositoryCommentsTab';

/**
 * Wrapper que obtiene los comentarios del F29 (companyId + period) de forma lazy
 * y renderiza RepositoryCommentsTab con la mutation propia del F29.
 */
const F29CommentsTab = ({ editData, companyIdOverride }) => {
  const companyId = editData?.companyId || companyIdOverride;
  const period = editData?.period;

  const { data: commentsData } = GetF29Comments({
    companyId,
    period,
    pause: !companyId || !period,
  });

  const createF29Comment = CreateF29Comment();

  // Memoizado para que `data` mantenga una referencia estable entre renders.
  // Si se recreara en cada render, el useEffect([data]) de RepositoryCommentsTab
  // reiniciaría las notas constantemente (parpadeo del comentario optimista).
  const comments = useMemo(
    () => commentsData?.getF29Comments || [],
    [commentsData],
  );

  const data = useMemo(
    () => ({
      id: `${companyId}-${period}`,
      companyId,
      innerComments: comments,
    }),
    [companyId, period, comments],
  );

  const onCommentCreated = async (input) => {
    // La mutation persiste el comentario y devuelve innerComments actualizado.
    // RepositoryCommentsTab agrega el comentario de forma optimista, por lo que
    // no se necesita un segundo round-trip (reexecuteQuery) para reflejarlo.
    const { error } = await createF29Comment.executeMutation({
      companyId,
      period,
      userId: input.user?.id,
      userName: input.user?.name,
      userEmail: input.user?.email,
      date: input.date,
      comment: input.comment,
    });
    if (error) throw error;
  };

  return (
    <RepositoryCommentsTab
      data={data}
      companyIdOverride={companyIdOverride}
      onCommentCreated={onCommentCreated}
      submitLoading={createF29Comment.fetching}
    />
  );
};

export default F29CommentsTab;
